import { RequirementRecordResponse, RequirementViewResponse } from "lib-klab-sdks";
import { Requirement, RequirementRecord } from "../../../domain/models/requirement/requirement.model";

export function mapRequirementRecord(source: RequirementRecordResponse): RequirementRecord {
  const { requirementId, ...fields } = source;
  return { id: requirementId, ...fields };
}

export function mapRequirement(source: RequirementViewResponse): Requirement {
  return {
    ...mapRequirementRecord(source),
    company: source.company,
    department: source.department,
    supplier: source.supplier,
    bankAccount: source.bankAccount,
    currency: source.currency,
    priorityLevel: source.priorityLevel,
    requester: source.requester ?? null,
    requesterDepartment: source.requesterDepartment ?? null,
    requirementStatus: source.requirementStatus,
    paymentStatus: source.paymentStatus,
    documentStatus: source.documentStatus,
    documentType: source.documentType,
  };
}
